import { createVanIconComponent } from "./van"

const AfterSale = createVanIconComponent("after-sale")
export default AfterSale
